PJQ.views.productionQuantities.ProductionQuantitiesDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Production Quantities have been created yet',
            zeroRecords: "No Production Quantities matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-production-quantities')
        },
        toggleRowClass: '.production-quantity-toggle-row'
    },
    events: {
        'click .btn-edit-production-quantity': 'viewProductionQuantityClicked',
        'click .btn-delete-production-quantity': 'deleteProductionQuantityClicked'
    },
    beforeRender: function () {
        this.options.order = _.size(this.options.subJobs) > 0 ? [[1, 'asc']] : [[0, 'asc']];
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['subJob', 'costCode', 'quantity', 'installedQuantity', 'remainingQuantity', 'description'];

        if (this.options.subJobs == null || _.size(this.options.subJobs) === 0) {
            includeColumns = _.without(includeColumns, 'subJob');
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'subJob':
                    columns.push({
                        "columnData": "subJob",
                        "data": "attributes.costCodeId",
                        "title": "Sub Job",
                        "width": "15%",
                        "render": _.bind(function (data, type, row) {
                            let costCode = this.options.costCodes.get(row.get('costCodeId')),
                                subJob;

                            if (costCode.get('subJobId')) {
                                subJob = this.options.subJobs.get(costCode.get('subJobId'));
                            }

                            return subJob ? subJob.get('name') : "";
                        }, this)
                    })
                    break;
                case 'costCode':
                    columns.push({
                        "columnData": "costCode",
                        "data": "attributes.costCodeId",
                        "title": "Cost Code",
                        "width": "300px",
                        "render": _.bind(function (data, type, row) {
                            let costCode = this.options.costCodes.get(data);
                            return costCode ? `${costCode.get('code')} - ${costCode.get('name')}` : "";
                        }, this)
                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "title": "Budgeted",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            let unit = this.options.unitsOfMeasure.get(row.get('unitId')),
                                uom = unit != null ? unit.get('code') : "",
                                res = (data ?? 0).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            return res + " " + (uom ?? "");
                        }, this)
                    });
                    break;
                case 'installedQuantity':
                    columns.push({
                        "columnData": "installedQuantity",
                        "data": "",
                        "title": "Installed",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            let unit = this.options.unitsOfMeasure.get(row.get('unitId')),
                                uom = unit != null ? unit.get('code') : "",
                                total = 0;

                            _.each(row.installedQuantities.models, (installedQuantity) => {
                                total += installedQuantity.get('quantity');
                            })

                            let res = total.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            return res + " " + (uom ?? "");
                        }, this)
                    });
                    break;
                case 'remainingQuantity':
                    columns.push({
                        "columnData": "remainingQuantity",
                        "data": "",
                        "title": "Remaining",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            let installed = 0;
                            _.each(row.installedQuantities.models, (installedQuantity) => {
                                installed += installedQuantity.get('quantity');
                            });

                            let total = ((row.get('quantity') ?? 0) - installed)

                            if (total < 0) {
                                total = 0;
                            }

                            let unit = this.options.unitsOfMeasure.get(row.get('unitId')),
                                uom = unit != null ? unit.get('code') : "",
                                res = total.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            return res + " " + (uom ?? "");
                        }, this)
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description",
                        "render": _.bind(function (data, type, row) {
                            return data;
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let canDelete = this.options.isAdmin,
                        res = '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-edit-production-quantity ml-1 fs-14"><span class="fal fa-pencil"></span></button>';

                    if (canDelete) {
                        res += '<button type="button" class="btn btn-danger btn-delete-production-quantity ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                    }

                    return `${res}</div>`;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "8%",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewProductionQuantityClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewProductionQuantity(row.data());
    },
    viewProductionQuantity: function (productionQuantity) {
        if (productionQuantity == null) {
            return;
        }

        if (typeof this.options.onViewProductionQuantity === 'function') {
            this.options.onViewProductionQuantity(productionQuantity);
        }
    },
    deleteProductionQuantityClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteProductionQuantity(row.data());
    },
    deleteProductionQuantity: function (productionQuantity) {
        if (productionQuantity == null) {
            return;
        }

        if (typeof this.options.onDeleteProductionQuantity === 'function') {
            this.options.onDeleteProductionQuantity(productionQuantity);
        }
    }
});

PJQ.views.productionQuantities.AddProductionQuantitiesDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'Click "Add Budgeted Quantity" to create a new Budgeted Quantity'
        }
    },
    events: {
        'click .btn-delete-production-quantity': 'deleteProductionQuantityClicked'
    },
    beforeRender: function () {
        this.options.isHideSearch = true;
    },
    deleteProductionQuantityClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteProductionQuantity(row);
    },
    deleteProductionQuantity: function (row) {
        if (row == null) {
            return;
        }

        if (typeof this.options.onDeleteProductionQuantity === 'function') {
            this.options.onDeleteProductionQuantity(row);
        }
    }
});

PJQ.views.productionQuantities.InstalledQuantitiesDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Installed Quantities have been added yet',
            zeroRecords: "No Installed Quantities matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-installed-quantities')
        },
    },
    events: {
        'click .btn-view-quantity': 'viewQuantityClicked',
        'click .btn-delete-quantity': 'deleteQuantityClicked',
        'click .btn-view-time-card': 'viewTimeCardClicked'
    },
    beforeRender: function () {
        this.options.project = this.options.project ?? PJQ.app.session.project;

        this.canViewTimeCard = this.options.project.permissions.hasPermission('timeCards.canView');
        this.timeCardSettings = new PJQ.models.timecards.TimeCardSettings(null, {
            project: PJQ.app.session.project
        });
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    getColumns: function () {
        let columns = [],
            includeColumns = ['description', 'quantity', 'installedOn', 'source'];

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description",
                        "render": _.bind(function (data, type, row) {
                            return data;
                        }, this)
                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "title": "Installed Quantity",
                        "width": "80px",
                        "render": _.bind(function (data, type, row) {
                            let total = 0;
                            total += data;

                            return total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                        }, this)
                    });
                    break;
                case 'installedOn':
                    columns.push({
                        "columnData": "installedOn",
                        "data": "attributes.installedOn",
                        "title": "Installed On",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return data ? moment(data).format('MM/DD/YYYY') : "N/A";
                        }, this)
                    });
                    break;
                case 'source':
                    columns.push({
                        "columnData": "source",
                        "data": "",
                        "title": "Source",
                        "width": "80px",
                        "render": _.bind(function (data, type, row) {
                            let timeCardId = row.get('timeCardId'),
                                html;

                            if (timeCardId > 0 && this.canViewTimeCard) {
                                html = '<button type="button" class="btn btn-link btn-view-time-card fs-14">View</button>'
                            } else {
                                html = 'Manual Entry';
                            }

                            return '<div class="text-align-center">' + html + '</div>';
                        }, this)
                    });
            }
        }, this));

        return columns;
    },
    viewTimeCardClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewTimeCard(row.data());
    },
    viewTimeCard: function (quantity) {
        let timeCardId = quantity.get('timeCardId');

        if (!timeCardId || !this.canViewTimeCard) {
            return;
        }

        let fnRenderTimeCard = () => {
            let model = new PJQ.models.timecards.TimeCard({
                timeCardId: timeCardId
            });

            model.fetch({
                success: () => {
                    new PJQ.views.timecards.TimeCardDetailsModal({
                        project: this.options.project,
                        model: model,
                        settings: this.timeCardSettings
                    });
                }
            });
        }

        if (!this.timeCardSettings.isFetched) {
            this.timeCardSettings.fetch({
                success: () => {
                    fnRenderTimeCard();
                }
            });
        } else {
            fnRenderTimeCard();
        }
    },
    viewQuantityClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewQuantity(row.data());
    },
    viewQuantity: function (quantity) {
        if (quantity == null) {
            return;
        }

        if (typeof this.options.onViewQuantity === 'function') {
            this.options.onViewQuantity(quantity);
        }
    },
    deleteQuantityClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteQuantity(row.data());
    },
    deleteQuantity: function (quantity) {
        if (quantity == null) {
            return;
        }

        if (typeof this.options.onDeleteQuantity === 'function') {
            this.options.onDeleteQuantity(quantity);
        }
    }
});

PJQ.views.productionQuantities.AddInstalledQuantitiesDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'Click "Add Quantity" to create a new Installed Quantity'
        }
    },
    beforeRender: function () {
        this.options.isHideSearch = true;
    },
    deleteQuantityClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteQuantity(row);
    },
    deleteQuantity: function (row) {
        if (row == null) {
            return;
        }

        if (typeof this.options.onDeleteQuantity === 'function') {
            this.options.onDeleteQuantity(row);
        }
    }
});